'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTriangle, iconTriangleTag } from '@ni/nimble-components/dist/esm/icons/triangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTriangle };
export { iconTriangleTag };
export const NimbleIconTriangle = wrap(IconTriangle);